export enum MapMode {
  NORMAL = 'NORMAL',
  BOX_SELECTION = 'BOX_SELECTION',
  POLYGON_SELECTION = 'POLYGON_SELECTION',
  POINT_SELECTION = 'POINT_SELECTION',
  INSPECTION = 'INSPECTION',
  DRAW = 'DRAW',
}
